import { getApiBaseUrl } from '@/lib/api/client';

/**
 * Builds the chat WebSocket URL with JWT query param (same contract as thread_demo).
 */
export function buildChatWebSocketUrl(token) {
  const rawToken = String(token || '').trim();
  if (!rawToken) {
    throw new Error('token is required for WebSocket URL');
  }

  const base = getApiBaseUrl();
  let httpUrl;
  try {
    httpUrl = new URL(base);
  } catch (_error) {
    throw new Error('invalid API base URL');
  }

  const wsProtocol = httpUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  const wsUrl = new URL(`${wsProtocol}//${httpUrl.host}/ws`);
  wsUrl.searchParams.set('token', rawToken);
  return wsUrl.toString();
}
